<fieldset ngModelGroup="experience{{index}}" class="experienceForm">
  <div class="row">
    <div class="col-sm-8">
      <div class="form-check">
        <mdb-checkbox mdbInput [mdbValidate]="false" name="currentlyEmployed{{randomNumber}}" id="currentlyEmployed{{randomNumber}}" class="form-check-input"
                      [(ngModel)]="experience.currentlyEmployed" (change)="adjustRelatedFieldsToCurrentlyEmployed()"></mdb-checkbox>
        <label class="form-check-label" for="currentlyEmployed{{randomNumber}}">Currently Employed</label>
      </div>
    </div>
    <div class="col-sm-4 text-right" *ngIf="index !== 0">
      <a href="javascript:void(0);" class="btn btn-link mt-2" (click)="remove.emit()">Remove Entry</a>
    </div>
  </div>
  <div class="row">
    <div class="col-sm-6">
      <div class="form-group">
        <label [class.required]="configuration.requireFromToDates" for="startDate{{index}}">From Date (mm/yyyy)<span *ngIf="!configuration.requireFromToDates"> (Optional)</span></label>
        <input #startDate="ngModel" id="startDate{{index}}" name="startDate" mdbInput mdbValidate type="text"
               [required]="configuration.requireFromToDates" pattern="^(0[1-9]|1[012])/\d{4}$" 
               class="form-control" [disabled]="!configuration.showFromToDates" [ngModel]="experience.startDate | date:'MM/yyyy':'UTC'"
               (ngModelChange)="onStartDateChanged($event)" />
        <mdb-error *ngIf="startDate.invalid && (startDate.dirty || startDate.touched)">Dates must be numeric in mm/yyyy format.</mdb-error>
      </div>
    </div>
    <div class="col-sm-6">
      <div class="form-group">
        <label [class.required]="configuration.requireFromToDates" for="endDate{{index}}">To Date (mm/yyyy)<span *ngIf="!configuration.requireFromToDates"> (Optional)</span></label>
        <input #endDate="ngModel" id="endDate{{index}}" name="endDate" mdbInput mdbValidate type="text"
               [disabled]="!configuration.showFromToDates || experience.currentlyEmployed" [required]="configuration.requireFromToDates" pattern="^(0[1-9]|1[012])/\d{4}$"
               class="form-control" [ngModel]="experience.endDate | date:'MM/yyyy':'UTC'" (ngModelChange)="onEndDateChanged($event)" />
        <mdb-error *ngIf="endDate.invalid && (endDate.dirty || endDate.touched)">Dates must be numeric in mm/yyyy format.</mdb-error>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-sm-6">
      <div class="form-group">
        <label [class.required]="configuration.requireEmployer" for="employer{{index}}">Employer<span *ngIf="!configuration.requireEmployer"> (Optional)</span></label>
        <input #employer="ngModel" id="employer{{index}}" name="employer" mdbInput mdbValidate type="text"
               [disabled]="!configuration.showEmployer" [required]="configuration.requireEmployer"
               class="form-control" [(ngModel)]="experience.employer" />
        <mdb-error *ngIf="employer.invalid && (employer.dirty || employer.touched)">Required field.</mdb-error>
      </div>
    </div>
    <div class="col-sm-6">
      <div class="form-group">
        <label [class.required]="configuration.requireJobTitle" for="jobTitle{{index}}">Title<span *ngIf="!configuration.requireJobTitle"> (Optional)</span></label>
        <input #jobTitle="ngModel" id="jobTitle{{index}}" name="jobTitle" mdbInput mdbValidate type="text"
               [disabled]="!configuration.showJobTitle" [required]="configuration.requireJobTitle" 
               class="form-control" [(ngModel)]="experience.title" />
        <mdb-error *ngIf="jobTitle.invalid && (jobTitle.dirty || jobTitle.touched)">Required field.</mdb-error>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-sm-6">
      <div class="form-group">
        <label [class.required]="configuration.requireCityState" for="city{{index}}">City<span *ngIf="!configuration.requireCityState"> (Optional)</span></label>
        <input #city="ngModel" id="city{{index}}" name="city" mdbInput mdbValidate type="text"
               [disabled]="!configuration.showCityState" [required]="configuration.requireCityState"
               class="form-control" [(ngModel)]="experience.city" />
        <mdb-error *ngIf="city.invalid && (city.dirty || city.touched)">Required field.</mdb-error>
      </div>
    </div>
    <div class="col-sm-6">
      <div class="form-group mdSelect stateSelect">
        <label [class.required]="configuration.requireCityState" for="province{{index}}">State<span *ngIf="!configuration.requireCityState"> (Optional)</span></label>
        <ng-select #province="ngModel" id="province{{index}}" name="province"
                   [disabled]="!configuration.showCityState" [required]="configuration.requireCityState"
                   [items]="provinces" [clearable]="false" placeholder="Select State..." [searchFn]="startsWithSearchFn"
                   class="hideCursor" [(ngModel)]="experience.province"></ng-select>
        <mdb-error *ngIf="province.invalid && (province.dirty || province.touched)">Required field.</mdb-error>
      </div>
    </div>
  </div>
  <div class="row" *ngIf="configuration.showJobNotes">
    <div class="col-sm-12">
      <div class="form-group">
        <label [class.required]="configuration.requireJobNotes" for="jobDescription{{index}}">Job Responsibilities Summary<span *ngIf="!configuration.requireJobNotes"> (Optional)</span></label>
        <textarea #jobDescription="ngModel" id="jobDescription{{index}}" name="jobDescription" mdbInput mdbValidate
                  [required]="configuration.requireJobNotes" rows="3" pattern="[\s\S]*\S[\s\S]*"
                  class="form-control md-textarea" [(ngModel)]="experience.jobDescription"></textarea>
        <mdb-error *ngIf="jobDescription.invalid && (jobDescription.dirty || jobDescription.touched)">Required field.</mdb-error>
      </div>
    </div>
  </div>
  <div class="row" *ngIf="configuration.showLeaveReason">
    <div class="col-sm-12">
      <div class="form-group">
        <label [class.required]="configuration.requireLeaveReason">Reason For Leaving<span *ngIf="!configuration.requireLeaveReason"> (Optional)</span></label>
        <textarea #reasonForLeaving="ngModel" id="reasonForLeaving{{index}}" name="reasonForLeaving" mdbInput mdbValidate
                  [required]="configuration.requireLeaveReason" rows="3" pattern="[\s\S]*\S[\s\S]*"
                  class="form-control md-textarea" [(ngModel)]="experience.reasonForLeaving"></textarea>
        <mdb-error *ngIf="reasonForLeaving.invalid && (reasonForLeaving.dirty || reasonForLeaving.touched)">Required field.</mdb-error>
      </div>
    </div>
  </div>
</fieldset>
